/**
 * Brand values for generated print documents.
 *
 * These documents are built in a detached `Document` (a popup or an iframe), so
 * they do NOT inherit the app's stylesheet — `var(--moe-color-…)` resolves to
 * nothing there, and the app theme's CSS custom properties are unavailable.
 * Literal values are therefore unavoidable in this one context.
 *
 * They are still sourced rather than invented: each is the brand token, or a
 * tone-derivation of it, from `src/services/theme.ts`. Print output is
 * customer-facing, so it should not drift from the application's palette.
 *
 * Print is always light-on-white — there is no dark mode for paper — so this
 * mirrors the light theme only.
 */
export const printBrand = {
	/** MOE Green — headings and rules. */
	primary: '#144835',
	/** Brand black — body copy. */
	text: '#2d2927',
	/** Secondary/supporting text. Tone 30 neutral; the package's own
	 *  `--moe-color-text-secondary` measures 3.40:1 on white and fails AA. */
	textMuted: '#474747',
	/** Hairline rules and table borders. */
	border: '#c6c6c6',
	/** Zebra striping and table headers. */
	surfaceSubtle: '#f1f2f2',
	surface: '#ffffff',

	/** Alpine Green at tone 45 — the published hex fails AA on white and black. */
	success: '#347935',
	/** Autumn at tone 45 — errors and adverse findings. */
	error: '#af4d2d',

	fontFamily: "Figtree, 'Segoe UI', system-ui, -apple-system, Roboto, Helvetica, Arial, sans-serif",
} as const
